module.exports = __webpack_public_path__ + "static/media/star-ball_06.f00ad195.png";